import { useDispatch, useSelector } from "react-redux";
import { setLedgerEnv } from "@/redux/actions/ledger-env-actions";

export const useLedgerEnv = () => {
  const dispatch = useDispatch();
  const environment = useSelector((s) => s.ledgerEnv?.environment ?? "LIVE");

  return {
    environment,
    isSandbox: environment === "SANDBOX",
    setEnvironment: (env) => dispatch(setLedgerEnv(env)),
  };
};
